import { render, staticRenderFns } from "./CardNavigation.vue?vue&type=template&id=bc76d6f0&scoped=true"
import script from "./CardNavigation.vue?vue&type=script&lang=js"
export * from "./CardNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc76d6f0",
  null
  
)

export default component.exports